import { LinkProps, Location, To } from "react-router-dom-v5-compat";

import { PartialLocation } from "common/types/routing";

import { CourseAddedLocation } from "seneca-common/features/class/analytics/events";
import {
  parser,
  StateParamType,
  type,
  Validator
} from "seneca-common/utils/routing/react-router-typesafe-routes/common";

import { ParentPlatformPreviewSource } from "features/teachers/features/analytics/class-management";
import { CreateAssignmentSource } from "features/teachers/features/assignment-journey/consts";
import { SelectedQuiz } from "features/teachers/features/assignment-journey/types";
import { AssignmentsTableMode } from "features/teachers/pages/assignment/components/AssignmentsInsightsTable/AssignmentsInsightsTable";
import {
  SchoolQuoteFormType,
  SchoolQuoteSources
} from "features/teachers/pages/what-is-premium/analytics/consts";

import { SUBSCRIPTION_JOURNEY_SOURCES } from "../features/subscriptions/analytics/consts";
import { PreselectClassesOption } from "../features/teachers/types";

export const locationType: StateParamType<Location, PartialLocation> = {
  getPlainStateParam(value: PartialLocation) {
    return value;
  },
  getTypedStateParam(value) {
    return value as Location;
  }
};

export const anyValidator: Validator<any> = (value: unknown): any => {
  return value as any;
};

export const toValidator: Validator<To> = (value: unknown): To => {
  return value as To;
};

const schoolQuoteSourcesValidator: Validator<SchoolQuoteSources> = (
  value: unknown
): SchoolQuoteSources => {
  return value as SchoolQuoteSources;
};

export const schoolQuoteSourcesType = type(
  schoolQuoteSourcesValidator,
  parser("string")
);

const schoolQuoteFormTypeValidator: Validator<SchoolQuoteFormType> = (
  value: unknown
): SchoolQuoteFormType => {
  return value as SchoolQuoteFormType;
};

export const schoolQuoteFormTypeType = type(
  schoolQuoteFormTypeValidator,
  parser("string")
);

const subscriptionJourneySourcesValidator: Validator<
  keyof typeof SUBSCRIPTION_JOURNEY_SOURCES
> = (value: unknown): keyof typeof SUBSCRIPTION_JOURNEY_SOURCES => {
  return value as keyof typeof SUBSCRIPTION_JOURNEY_SOURCES;
};

export const subscriptionJourneySourcesType = type(
  subscriptionJourneySourcesValidator
);

const createAssignmentSourceValidator: Validator<CreateAssignmentSource> = (
  value: unknown
): CreateAssignmentSource => {
  return value as CreateAssignmentSource;
};

export const createAssignmentSourceType = type(createAssignmentSourceValidator);

const courseAddedLocationValidator: Validator<CourseAddedLocation> = (
  value: unknown
): CourseAddedLocation => {
  return value as CourseAddedLocation;
};

export const courseAddedLocationType = type(
  courseAddedLocationValidator,
  parser("string")
);

const preselectClassesOptionValidator: Validator<PreselectClassesOption> = (
  value: unknown
): PreselectClassesOption => {
  return value as PreselectClassesOption;
};

export const preselectClassesOptionType = type(
  preselectClassesOptionValidator,
  parser("string")
);

export const parentPlatformPreviewSourceType: StateParamType<ParentPlatformPreviewSource> =
  {
    getPlainStateParam(value: ParentPlatformPreviewSource) {
      return value;
    },
    getTypedStateParam(value) {
      return value as unknown as ParentPlatformPreviewSource;
    }
  };

const linkPropsTypeValidator: Validator<LinkProps> = (
  value: unknown
): LinkProps => {
  return value as LinkProps;
};

export const linkPropsType = type(linkPropsTypeValidator);

export const assignmentsTableModeType: StateParamType<AssignmentsTableMode> = {
  getPlainStateParam(value: AssignmentsTableMode) {
    return value;
  },
  getTypedStateParam(value) {
    return value as unknown as AssignmentsTableMode;
  }
};

export const selectedQuizzesValidator: Validator<SelectedQuiz[]> = (
  value: unknown
): SelectedQuiz[] => {
  return value as SelectedQuiz[];
};

export const selectedQuizzesType = type(selectedQuizzesValidator);
